/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Office_Logo_UnavailableInputs */

const cs_settings_office_logo_unavailable = /** @type {(inputs: Settings_Office_Logo_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logo nedostupné`)
};

const en_settings_office_logo_unavailable = /** @type {(inputs: Settings_Office_Logo_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logo unavailable`)
};

/**
* | output |
* | --- |
* | "Logo unavailable" |
*
* @param {Settings_Office_Logo_UnavailableInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_office_logo_unavailable = /** @type {((inputs?: Settings_Office_Logo_UnavailableInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Office_Logo_UnavailableInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_office_logo_unavailable(inputs)
	return cs_settings_office_logo_unavailable(inputs)
});